import { render, staticRenderFns } from "./courseMini.vue?vue&type=template&id=f5800cb0&scoped=true"
import script from "./courseMini.vue?vue&type=script&lang=js"
export * from "./courseMini.vue?vue&type=script&lang=js"
import style0 from "./courseMini.vue?vue&type=style&index=0&id=f5800cb0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5800cb0",
  null
  
)

export default component.exports